import api from '@/utils/api';
import {
    GET_LIST_INTERACTION_TYPE,
    GET_SPECIFIC_INTERACTION_TYPE,
    UPDATE_SPECIFIC_INTERACTION_TYPE,
    CREATE_NEW_INTERACTION_TYPE,
    REMOVE_INTERACTION_TYPE,
    GET_INTERACTION_TYPE_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListInteractionType = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-types', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_INTERACTION_TYPE, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificInteractionType = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/interaction-types/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_INTERACTION_TYPE, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getInteractionTypeActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-types/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_INTERACTION_TYPE_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createInteractionType = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/interaction-types', data).then(res => {
            dispatch({ type: CREATE_NEW_INTERACTION_TYPE, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateInteractionType = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/interaction-types/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_INTERACTION_TYPE, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeInteractionType = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/interaction-types`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_INTERACTION_TYPE, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
